module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('ul', {
    staticClass: "search_ul"
  }, _vm._l((_vm.productList), function(item) {
    return _c('li', {
      key: item._id,
      staticClass: "search_li",
      class: {
        'search_li_active': _vm.productionId === item._id
      },
      on: {
        "click": function($event) {
          _vm.handleClick(item._id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _c('i')])
  }))]), _c('div', {
    staticClass: "wapper"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs-nav"
  }, _vm._l((_vm.tabsList), function(item) {
    return _c('div', {
      key: item.name,
      staticClass: "tab",
      class: {
        'active': _vm.$route.name === item.name
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.name,
        "replace": ""
      }
    }, [_vm._v(_vm._s(item.label))])], 1)
  })), (_vm.childChange) ? _c('div', {
    staticClass: "tabs-content"
  }, [_c('transition', {
    attrs: {
      "name": "slide-left"
    }
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)], 1) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a176177!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductDocument/Index.vue
// module id = 407
// module chunks = 0